// material-ui
import { Stack, Grid, Skeleton } from '@mui/material';

// ==============================|| SKELETON - TABLE FOOTER ||============================== //

const SkeletonTableFooter = () => (
    <Grid
        container
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent={{ xs: 'center', sm: 'space-between' }}
        alignItems="center"
        spacing={2}
    >
        <Grid item>
            <Stack direction="row" spacing={1}>
                <Skeleton variant="rectangular" width={150} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={40} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={40} height={28} sx={{ borderRadius: '2px' }} />
            </Stack>
        </Grid>
        <Grid item>
            <Stack direction="row" spacing={1}>
                <Skeleton variant="rectangular" width={40} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={40} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={40} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={40} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={40} height={28} sx={{ borderRadius: '2px' }} />
            </Stack>
        </Grid>
    </Grid>
);

export default SkeletonTableFooter;
